import React, { useEffect, useState, useMemo, useRef } from 'react';
import { AgGridReact } from 'ag-grid-react';
import '@ag-grid-community/styles/ag-grid.css';
import '@ag-grid-community/styles/ag-theme-quartz.css';
import { Header } from '@backstage/core-components';
import 'ag-grid-enterprise';
import Loader from '../loader/Loader';
import { discoveryApiRef, useApi, fetchApiRef, identityApiRef } from '@backstage/core-plugin-api';
import '../NoteCustomstyle.css';

//  import Material UI dropdown components
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';

const KeyManagementService = () => {
  const gridRef = useRef<any>(null);
  const containerStyle = useMemo(() => ({ width: "100%", height: "100vh" }), []);
  const gridStyle = useMemo(() => ({ height: 'calc(-200px + 80vh)', width: "100%", marginTop: '50px' }), []);
  const [rowData, setRowdata] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [org, setOrg] = useState('');
  const [tenantName, settenantName] = useState<string>(''); //  state for dropdown
  const discoveryApi = useApi(discoveryApiRef);
  const fetchApi = useApi(fetchApiRef);
  const [role, setRole] = useState('')
  const [tenantsFromDb, setTenantsFromDb] = useState<any[]>([]);
  const [tenantId, setTenantId] = useState('');
  const identityApi = useApi(identityApiRef)

  const fetchTenantsFromDb = async () => {
    try {
      const baseUrl = await discoveryApi.getBaseUrl('user');
      const response = await fetchApi.fetch(`${baseUrl}/tenants`);
      if (!response.ok) throw new Error("Failed to fetch tenants");
      return await response.json();
    } catch (e) {
      console.error("Error fetching tenants:", e);
      return [];
    }
  };

  const fetchTenant = async () => {
    try {
      const details = await identityApi.getBackstageIdentity();
      const id = details.ownershipEntityRefs.find(ref =>
        ref.startsWith('tenantId:')
      )?.split(':')[1] || null;

      console.log("ID ---------", id)
      return id;
    } catch (err) {
      console.error('Failed to get tenantId:', err);
      setTenantId(null);
    }
  };

  useEffect(() => {
    try {
      const fetchData = async () => {
        try {
          const tenants = await fetchTenantsFromDb();
          const id = await fetchTenant()
          console.log(`orgName:${id}`)
          const tenantOrgName = localStorage.getItem(`orgName:${id}`);
          console.log('tenantOrgName------',tenantOrgName)
          if (tenantOrgName) setOrg(tenantOrgName);
          setTenantsFromDb(tenants);
          const baseurl = await discoveryApi.getBaseUrl('user');
          let data: any[] = [];
          try {
            const fetchresponse = await fetchApi.fetch(`${baseurl}/kms-cost`, {
              method: 'POST',
            });
            if (!fetchresponse.ok) {
              const errorText = await fetchresponse.text();
              throw new Error(`API error: ${fetchresponse.status} - ${errorText}`);
            }
            let response = await fetchresponse.json();
            let role = response.role
            setRole(role)
            data = response.data || []
            console.log('Fetched data:', data);
          } catch (error) {
            console.error('Fetch or JSON parse error:', error);
          }

          // Parse potentialSavings field
          const filterData = data
            .filter(item => item.totalCost > 0)
            .map(item => ({
              ...item,
              potentialSavings: item.potentialSavings // Parse JSON string to object
            }));

          setRowdata(filterData);
          setLoading(false);
        } catch (error) {
          setLoading(false);
        }
      };

      fetchData();

      let orgName = localStorage.getItem('orgName');
      if (orgName) {
        setOrg(orgName);
      }
    } catch (error) {
    }
  }, []);

  const columnDefs = useMemo(() => {
    const baseCols = [
      { headerName: "Tenant Name", field: "tenantName", headerTooltip: "Tenant Name", rowGroup: true },
      { headerName: "Account Id", field: "accountId", headerTooltip: "Account Id", rowGroup: true },
      { headerName: 'Region', field: 'region', headerTooltip: "Region" },
      { headerName: 'Customer Keys Count', field: 'keysCount', headerTooltip: "Key Count" },
      {
        headerName: 'Cost in $', field: 'totalCost', aggFunc: 'sum', headerTooltip: 'Cost in $',
        valueFormatter: params => {
          const value = parseFloat(params.value);
          if (!isNaN(value)) return value.toFixed(2);
        },
      },
      {
        headerName: 'Potential Cost Savings on Unused Keys($)',
        field: 'potentialSavings.unusedKeySavings',
        aggFunc: 'sum', hide: true, headerTooltip: 'Unused Key Savings',
        valueFormatter: params => {
          const value = parseFloat(params.value);
          if (!isNaN(value)) return value.toFixed(2);
        }
      },
      {
        headerName: 'Potential Cost Savings on Request($)',
        field: 'potentialSavings.requestSavings',
        aggFunc: 'sum', hide: true, headerTooltip: 'Request Savings',
        valueFormatter: params => {
          const value = parseFloat(params.value);
          if (!isNaN(value)) return value.toFixed(2);
        }
      },
      {
        headerName: 'Potential Cost Savings on HSM($)',
        field: 'potentialSavings.hsmSavings',
        aggFunc: 'sum', hide: true, headerTooltip: 'HSM Savings',
        valueFormatter: params => {
          const value = parseFloat(params.value);
          if (!isNaN(value)) return value.toFixed(2);
        }
      },
      {
        headerName: 'Potential Cost Savings',
        field: 'totalCostSaving',
        aggFunc: 'sum', headerTooltip: 'Potential Cost Savings',
        valueFormatter: params => {
          const value = parseFloat(params.value);
          if (!isNaN(value)) return value.toFixed(2);
        }
      }
    ];
  
    return baseCols.map(col =>
      col.field === "tenantName"
        ? { ...col, hide: role != "SuperAdmin", rowGroup: role != "SuperAdmin" ? false : col.rowGroup }
        : col
    );
  }, [role]);
  

  const defaultColDef = useMemo(() => {
    return {
      flex: 1, filter: true, sortable: true, resizable: true, enableRowGroup: true, tooltipShowDelay: 0, tooltipInteraction: true, columnMenu: "new"
    };
  }, []);

  const autoGroupColumnDef = {
    minWidth: 250,
    cellRendererParams: {
      footerValueGetter: (params) => {
        const isRootLevel = params.node.level === -1;
        if (isRootLevel) {
          return "Total";
        }
        return "Sub Total";
      },
    },
  }

  const sideBar = {
    toolPanels: [
      {
        id: 'columns',
        labelDefault: 'Columns',
        labelKey: 'columns',
        iconKey: 'columns',
        toolPanel: 'agColumnsToolPanel',
      }
    ],
    defaultToolPanel: '',
  }


  const gridOptions = { suppressContextMenu: true };

  //  filter data based on selected tenant
  const filteredData = tenantName
    ? rowData.filter(row => String(row.tenantName) === String(tenantName))
    : rowData;

  //  extract unique tenants
  const tenants = [...new Set(rowData.map(r => r.tenantName))];
  console.log("Tenants in dropdown:", tenants);
  return (
    <div style={containerStyle}>
      <div>
        <Header title="Key Management Service" subtitle={`${org}`} />
      </div>

      {/* Dropdown below header, right aligned */}
      {role === "SuperAdmin" && (
      <div style={{ display: "flex", justifyContent: "flex-end", margin: "10px 0" }}>
        <FormControl variant="outlined" size="small" style={{ minWidth: 200 }}>
          <InputLabel></InputLabel>
          <Select
            value={tenantName}
            onChange={(e) => settenantName(e.target.value)}
            displayEmpty
            MenuProps={{
              PaperProps: {
                sx: {
                  // force vertical stacking
                  '& .MuiList-root': {
                    display: 'flex !important',
                    flexDirection: 'column !important',
                  },
                  // force left-aligned text inside items
                  '& .MuiMenuItem-root': {
                    justifyContent: 'flex-start',
                    pl: 2,
                  },
                },
              },
            }}
          >
          <MenuItem value="">All Tenants</MenuItem>
          {tenantsFromDb.map((tenant) => (
            <MenuItem key={tenant.id} value={tenant.name}>
              {tenant.name}
            </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
      )}

      {loading ? (<Loader />) : (
        <div>
          <div className="ag-theme-quartz resourcecost" style={{ ...gridStyle, marginTop: 10 }}>
            <AgGridReact
              ref={gridRef}
              rowData={filteredData}
              columnDefs={columnDefs}
              autoGroupColumnDef={autoGroupColumnDef}
              rowGroupPanelShow={"always"}
              sideBar={sideBar}
              defaultColDef={defaultColDef}
              groupIncludeFooter={true}
              groupIncludeTotalFooter={true}
              groupDefaultExpanded={-1}
              suppressAggFuncInHeader={true}
              gridOptions={gridOptions}
            />
          </div>
          <div className="recommended-action-container">
            <div className="scroll-container">
              <strong>Recommended Action</strong>
              <ul>
                <li>
                  <strong>Review and Optimize KMS Key Usage and HSM Configurations</strong>
                  <p>To ensure proper management and security of encryption resources, it's important to systematically review KMS key metadata across your AWS accounts and regions.</p>
                  <ul>
                    <li>Fetch KMS Keys: Retrieve metadata for KMS keys across all relevant AWS accounts and regions.</li>
                    <li>Gather HSM Information: Collect metadata and status information for any HSMs in use, including configuration and usage details.</li>
                    <li>Gather Metrics: Use CloudWatch to collect and analyze encryption and decryption metrics for each key.</li>
                  </ul>
                  <p>Considerations:</p>
                  <ul>
                    <li>Permissions: Ensure your AWS roles have the necessary permissions to access KMS, HSM, and CloudWatch metrics.</li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
          <div className="note-container">
            <p>
              <strong>Note*</strong><span className="note-text">: Potential cost savings here are calculated by identifying and potentially deleting unused KMS keys, optimizing the number of chargeable API requests, and reducing HSM usage. Savings are based on eliminating costs for unused keys, minimizing requests that exceed free tiers, and reducing HSM instance hours.</span>
            </p>
          </div>
        </div>
      )}
    </div>
  )
}

export default KeyManagementService;
